import type { RestoreWizardConfig } from '../types'

export const ACCESS_WIZARD_CONFIG: RestoreWizardConfig = {
  kind: 'ACCESS_INTEGRATION',
  kindLabel: 'Access & Integrations Restore',
  unitIds: { select: 'access-wz-1', repositories: 'access-wz-2', targets: 'access-wz-3', plan: 'access-wz-4', order: 'access-wz-5' },
  targetScopeForm: 'REPOSITORIES',
  singleRef: false,
}
